import React from "react";

const StatsAndDiscoverSection = () => {
  return (
    <section className="w-full bg-white">
      {/* ===== Stats Bar ===== */}
      <div className="w-full bg-[#d8e6ee]">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
            {/* Stat 1 */}
            <div className="flex flex-col items-center">
              <img
                src="/assets/project-done.png"
                alt="Projects done"
                className="h-12 w-12 mb-2"
              />
              <p className="text-sm font-medium text-gray-700">Project done</p>
              <p className="text-xl font-bold text-[#0b4864]">20+</p>
            </div>

            {/* Stat 2 */}
            <div className="flex flex-col items-center">
              <img
                src="/assets/happy-client.png"
                alt="Happy clients"
                className="h-12 w-12 mb-2"
              />
              <p className="text-sm font-medium text-gray-700">Happy Client</p>
              <p className="text-xl font-bold text-[#0b4864]">10+</p>
            </div>

            {/* Stat 3 */}
            <div className="flex flex-col items-center">
              <img
                src="/assets/satisfaction.png"
                alt="Satisfaction rate"
                className="h-12 w-12 mb-2"
              />
              <p className="text-sm font-medium text-gray-700">
                Satisfaction rate
              </p>
              <p className="text-xl font-bold text-[#0b4864]">95+</p>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Discover Section ===== */}
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left Content */}
          <div>
            <h3 className="text-[#0b4864] font-bold text-2xl sm:text-3xl">
              Discover
            </h3>

            <p className="mt-2 text-sm font-semibold text-gray-900">
              How We Help Your Business Grow
            </p>

            <p className="mt-4 max-w-xl text-gray-700 text-sm sm:text-base leading-7">
              At Digital Transformation Associates, we focus on empowering
              businesses to succeed in a digital-first world. Through customized
              digital marketing, web design, and software development solutions,
              we enhance your online visibility, strengthen customer engagement,
              and streamline operations. We work as your trusted partner,
              committed to delivering sustainable growth and long-term success
              in a competitive market place.
            </p>
          </div>

          {/* Right Image */}
          <div className="flex justify-center lg:justify-end">
            <img
              src="/assets/discover-team.webp"
              alt="Team collaboration"
              className="w-full max-w-md lg:max-w-lg rounded-2xl object-cover aspect-[16/10]"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsAndDiscoverSection;
